<template>
  <div class="choose__behaviour">
    <option-select v-model="action" :options="actions" @input="onActionChanged"></option-select>
    <!---->
    <div v-if="action === 'jumpTo'" class="target-time-wrapper indent-1">
      <time-picker 
        :tags="tags"
        :value="value"
        :controls="{start:true, end:true}"
        :frameRate="getFrameRate"
        @startTime="onStartTime"
        @endTime="onEndTime"
        @newTime="onNewTime">
      </time-picker>
      <label for="modifier">then</label>
      <option-select v-model="modifier" :options="jumpToModifiers" @input="onModifierChanged"></option-select>
    </div>
    <!---->
    <div v-if="action === 'sleep'" class="target-time-wrapper indent-1">
      <label for="target-time">sleep (ms):</label>
      <input type="text" name="target-time" v-validate="'required'" class="target-time" v-model="value" v-on:blur="onValueChanged" />
      <span class="invalid">{{ errors.first('target-time') }}</span>
    </div>
    <div v-if="action === 'open'" class="indent-1">
      <label for="target-url">URL to open<lang-toggler v-if="value.lang" :lang="value.lang ? value.lang : 'de'" @input="value.lang = $event" @applyAll="copyCurrentValueToAllLangs(value, $event)"/></label>
      <input type="text" name="target-url" class="target-url" v-validate="'required|url'" v-model="value[value.lang]" v-on:blur="onValueLangChanged" />
      <span class="invalid">{{ errors.first('target-url') }}</span>
      <button style="margin-top:6px" title="get url from Pinwall" @click.stop.prevent="showPinwall=!showPinwall" class="icon-button">Pinwall</button>
      <pinwall v-on:inputAsset="updateUrl" v-on:close="showPinwall=false" v-if="showPinwall"></pinwall>
      <button style="margin-top:6px" title="get url from Kaltura" @click.stop.prevent="showKaltura=!showKaltura" class="icon-button">Kaltura</button>
      <kaltura v-on:inputMedia="updateUrl" v-on:close="showKaltura=false" v-if="showKaltura"></kaltura>
      <label for="url-target">do open in:</label>
      <option-select v-model="target" name="do-open-in" v-validate="'required'" :options="targetOptions" @input="onTargetChanged"></option-select>
      <span class="invalid">{{ errors.first('do-open-in') }}</span>
      <label for="modifier">video after open:</label>
      <option-select v-model="modifier" :options="jumpToModifiers" @input="onModifierChanged"></option-select>
    </div>
    <div v-if="action === 'open-asset'" class="indent-1">
      <label for="load-asset">choose video asset</label>
      <asset-select name="load-asset" v-model="target" :assets="assets" @input="onTargetChanged"></asset-select>
      <label for="modifier">next video asset:</label>
      <option-select v-model="modifier" :options="jumpToModifiers" @input="onModifierChanged"></option-select>
      <label for="target-time">time:</label>
      <input type="text" name="target-time" class="target-url" v-model="value" v-on:blur="onValueChanged" />
    </div>
    <div v-if="action === 'post-message'" class="indent-1">
      <label for="post-message-payload">payload as JSON</label>
      <textarea name="post-message-payload" v-model="jsonValue" v-on:blur="onJSONValueChanged" />
    </div>
    <div v-if="action === 'toggle-tag'" class="indent-1">
      <label for="select-tag">select tag</label>
      <tag-select v-model="target" :tags="tags" @input="onTargetChanged"></tag-select>
      <label for="modifier">after toggle:</label>
      <option-select v-model="modifier" :options="jumpToModifiers" @input="onModifierChanged"></option-select>
    </div>
  </div>
</template>

<script>
const defaultModifiers = [
  {
    id: null,
    label: "nothing"
  },
  {
    id: "pause",
    label: "pause"
  },
  {
    id: "play",
    label: "play"
  },
  {
    id: "toggle",
    label: "toggle play / pause"
  }
];
const defaultActions = [
  {
    id: null,
    label: "nothing"
  },
  {
    id: "pause",
    label: "pause"
  },
  {
    id: "play",
    label: "play"
  },
  {
    id: "toggle",
    label: "toggle play / pause"
  },
  {
    id: "jumpTo",
    label: "jump to time"
  },
    {
    id: "sleep",
    label: "sleep"
  },
  {
    id: "open",
    label: "open URL"
  },
  {
    id: "open-asset",
    label: "branching"
  },
  {
    id: "toggle-tag",
    label: "toggle tag"
  },
  {
    id: "post-message",
    label: "post message to iFrame"
  }
  /*
  {
    id: "openLightbox",
    label: "open lightbox"
  },
  {
    id: "openFrame",
    label: "open iFrame"
  }
  */
];
const defaultTargetOptions = [
  {
    id: "iframe",
    label: "lightbox"
  },
  {
    id: "_blank",
    label: "new window"
  },
  {
    id: "_self",
    label: "same window"
  }
];
import { mapGetters, mapState, mapMutations } from "vuex";
import optionSelect from "./optionSelect";
import assetSelect from "./assetSelect";
import tagSelect from "./tagSelect";
import LangToggler from './langToggler'
import { multiLangTextObject } from './../../utils/multiLang.js'
import Pinwall from "../pinwall"
import Kaltura from "../kaltura"
import timePicker from '../core/timePicker'

export default {
  name: "chooseBehaviour",

  components: {
    optionSelect,
    assetSelect,
    tagSelect,
    LangToggler,
    Pinwall,
    Kaltura,
    'time-picker': timePicker
  },

  props: ["modelItem"],

  data() {
    return {
      action: "none",
      value: null,
      modifier: null,
      target: null,
      showPinwall: false,
      showKaltura: false
    };
  },

  computed: {
    ...mapGetters(["currentTime", "assets", "tags", 'getFrameRate', 'videoDuration']),
    ...mapState(["selection"]),

    jumpToModifiers() {
      let modifiers = []

      if (this.action === "open-asset") {
        defaultModifiers.forEach((o) => {
          if(o.id === null || o.id !== "toggle") {
            modifiers.push(o)
          }
        })
      } else {
        modifiers = defaultModifiers
      }

      return modifiers;
    },

    actions() {
      return defaultActions;
    },

    targetOptions() {
      return defaultTargetOptions;
    },

    jsonValue: {
      get: function() {
        return JSON.stringify(this.value)
      },
      set: function(val) {
        // noop
      }
    }
  },

  watch: {
    "modelItem.value": "init"
  },

  created() {
    this.init();
  },

  methods: {
    ...mapMutations(['setPlayerTime', 'resetSelection']),

    init() {
      let val = this.modelItem.value || {};
      // action like jumpTo
      this.action = val.action;
      // value like time value for jumpTo
      this.value = val.value;
      //  modifier [play | pause]
      this.modifier = val.modifier;
      // target _self, _blank
      this.target = val.target;
    },

    onActionChanged() {
      console.log("onActionChanged", this.action);
      this.value = null;
      this.modifier = null;
      if (this.action === "open") {
        this.value = multiLangTextObject()
      }
      if (this.action === "jumpTo") {
        this.value = 0
      }
      this.emit();
    },

    onNewTime: function (time) {
      const newTime = time > this.videoDuration ? this.videoDuration - 0.1 : time
      this.value = newTime
      this.emit()
    },

    onTimeChanged() {
      this.value = this.currentTime;
      this.emit();
    },

    onValueChanged() {
      this.emit();
    },

    onJSONValueChanged(ev) {
      try {
        this.value = JSON.parse(ev.target.value)
      } catch (err) {
        this.value = null
        return
      }
      this.onValueChanged();
    },

    onValueLangChanged() {
      this.emit();
    },

    onStartTime() {
      const wps = this.selection.scene.waypoints;
      const minWp = wps.reduce((prev, current) => {
        return prev.time < current.time ? prev : current;
      });
      this.value = minWp.time;
      this.emit();
    },

    onEndTime() {
      const wps = this.selection.scene.waypoints;
      const maxWp = wps.reduce((prev, current) => {
        return prev.time > current.time ? prev : current;
      });
      this.value = maxWp.time + 0.1;
      this.emit();
    },

    onModifierChanged(value) {
      console.log("onModifierChanged", value);
      this.emit();
    },

    onTargetChanged(value) {
      console.log("onTargetChanged", value);
      this.emit();
    },

    copyCurrentValueToAllLangs: function(item, ev) {
      let val = this.value[ev]
      for (const k in this.value) {
        if (k !== 'lang') {
          this.value[k] = val
        }
      }
      this.emit()
    },

    updateUrl(event) {
      this.value[this.value.lang] = event.url
      this.showPinwall = false
      this.showKaltura = false
      this.emit()
    },

    emit() {
      this.modelItem.value = {
        action: this.action,
        value: this.value,
        modifier: this.modifier,
        target: this.target
      };
      this.$emit("pick", this.modelItem.value);
    }
  }
};
</script>
